import React, { useContext, useState } from "react";
import Button from 'react-bootstrap/Button';
import { DataContext } from "../../../js/App";
import FormContainer from "../../FormContainer";
import "./repeater.scss";

const Repeater = ({ name, fieldLabel, options, addText, title }) => {
  const context = useContext(DataContext);
  const [repeaterRows, setRepeaterRows] = useState(0);
  const increaseRepeaterRows = () =>{
    setRepeaterRows(repeaterRows + 1);
  }
  const repeaterArray = [];
  for(let i = 0; i <= repeaterRows; i++){
    repeaterArray.push(<FormContainer key={name+"_" + i} index={-1} fields={options.fields} appendName={name+"_" + i +"_"} labelName={(title !== "" ? title : fieldLabel) + " "+(i+1)}/>);
  }
  repeaterArray.push(<Button key={name+"_button"} variant="primary" onClick={() => increaseRepeaterRows()}>{addText}</Button>)
  return (<><div className="repeater-container">{repeaterArray}</div></>);
};

export default Repeater;
